const INSERT_NEW_NOTIFICATION = 'INSERT_NEW_NOTIFICATION';
const TOGGLE_NOTIFICATIONS_LIST = 'TOGGLE_NOTIFICATIONS_LIST';
const DELETE_EXPIRED_NOTIFICATION = 'DELETE_EXPIRED_NOTIFICATION';

const insertNewNotification = (payload) => ({
    type: INSERT_NEW_NOTIFICATION,
    payload,
    track: payload.track,
});

const deleteExpiredNotification = () => (dispatch) => {
    dispatch({ type: DELETE_EXPIRED_NOTIFICATION });
};

const beginExpiringNewNotification = () => (dispatch) => {
    setTimeout(() => dispatch(deleteExpiredNotification()), 3500);
};

const createNewNotification = (payload) => (dispatch) => {
    dispatch(insertNewNotification(payload));
    dispatch(beginExpiringNewNotification());
};

export default (state = { message: null }, action) => {
    switch (action.type) {
        case INSERT_NEW_NOTIFICATION:
            return {
                ...state,
                message: action.payload.message,
            };

        case DELETE_EXPIRED_NOTIFICATION:
            return {
                ...state,
                message: null,
            };

        default:
            return state;
    }
};

export {
    INSERT_NEW_NOTIFICATION,
    TOGGLE_NOTIFICATIONS_LIST,
    DELETE_EXPIRED_NOTIFICATION,
    createNewNotification,
    insertNewNotification,
    deleteExpiredNotification,
    beginExpiringNewNotification,
};
